import React from "react";
import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

export default function Sparkline({ data = [], color = "#39c8c1", height = 32 }) {
    if (!data || data.length === 0) {
        return <div style={{ height }} className="bg-light-bg/40 rounded" />;
    }
    const series = data.map((v, i) =>
        typeof v === "number" ? { i, v } : { i, v: v.value ?? v.count ?? 0 },
    );
    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={series} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
                <YAxis hide domain={["dataMin", "dataMax"]} />
                <Line
                    type="monotone"
                    dataKey="v"
                    stroke={color}
                    strokeWidth={2}
                    dot={false}
                    isAnimationActive={true}
                />
            </LineChart>
        </ResponsiveContainer>
    );
}
